import { PeriodoLimiteModel } from './../models/limits';
import { Router } from '@angular/router';
import { SelectedLimitData, TransfersDataViewModel } from '../models/select-ajust-limits';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';

import { PixLimitsService } from '../../pix/limits/limits.service'
import { LimitsService } from '../limits.service';


@Component({
  selector: 'app-limits-select-adjust-limits',
  templateUrl: './select-adjust-limits.component.html',
  styleUrls: ['./select-adjust-limits.component.styl'],
  encapsulation: ViewEncapsulation.None
})
export class LimitsSelectAdjustLimitsComponent implements OnInit {
	public previousViewData: TransfersDataViewModel;
	public nextViewData: SelectedLimitData = new SelectedLimitData();

	constructor(
		private router: Router,
		public dialog: MatDialog,
		public pixLimitsService: PixLimitsService,
		public limitsService: LimitsService,
	) { }

	ngOnInit() {
		this.previousViewData = new TransfersDataViewModel();
		this.previousViewData = JSON.parse(sessionStorage.getItem('limitTransferData'));
	}

	limitInAnalysis(periodLimit: PeriodoLimiteModel): boolean{
		return (!!periodLimit.valorLimiteRequisitado && periodLimit.valorLimiteRequisitado > 0) ? true : false;
	}

	getValueLimit(limit: PeriodoLimiteModel): number {
		return limit.valorLimiteRequisitado ? limit.valorLimiteRequisitado : limit.valor;
	}

	showDayTransfers = (): boolean => (this.previousViewData.limitViewModel.limiteDiurno.valor && !!this.previousViewData.limitViewModel.limiteDiurno.horarioInicial && !!this.previousViewData.limitViewModel.limiteDiurno.horarioFinal);

	showNightTransfers = (): boolean => (this.previousViewData.limitViewModel.limiteNoturno.valor && !!this.previousViewData.limitViewModel.limiteNoturno.horarioInicial && !!this.previousViewData.limitViewModel.limiteNoturno.horarioFinal);

	goToAdjustLimit(limit: PeriodoLimiteModel): void {
		this.saveTransferModelData(limit);
		this.router.url === '/minha-conta/meus-limites/selecionar-limite' ? this.router.navigate(['/minha-conta/meus-limites/alterar-limite']) : this.router.navigate(['/pix/limites/alterar-limite']);
	}

	saveTransferModelData(data: PeriodoLimiteModel ): void {
		sessionStorage.removeItem('selectedlimitTransferData');
		sessionStorage.setItem('selectedlimitTransferData', JSON.stringify(data));
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limits/select-adjust-limits/select-adjust-limits.component.ts